// 本地配置, 并且不提交git
// 建议使用命令行操作，选择local 环境时自动写入
// yarn server-map --add
// yarn server-suffix --add
module.exports = {
  localServerMap: {
    baseServer: {
      path: '/cleword-explore/surfer-modelling',
      domain: 'pandateacher.com',
      subDomain: 'test',
      protocol: 'https:',
      port: ''
    }
  },
  localServerSuffix: {}
};
